export default {
  sections: {
    alcohol_percentage: 'Alkoholindhold: {{value}}%',
    price_per_unit: 'Pris pr. {{unit}}: {{value}}',
    gtin: 'GTIN',
    ingredients: 'Ingredienser',
    allergens: 'Allergener',
    additives: 'Tilsætningsstoffer',
    nutrition_breakdown: {
      title: 'Næringsindhold',
      description: '100 {{unit}} indeholder:',
      items: {
        energy: 'Energi',
        fat: 'Fedt',
        saturates: 'heraf mættede fedtsyrer',
        carbohydrates: 'Kulhydrater',
        sugars: 'heraf sukkerarter',
        protein: 'Protein',
        salt: 'Salt',
      },
    },
  },
  units: {
    l: 'liter',
    kg: 'kilo',
    default: 'enhed',
  },
};
